import { useEffect, useState } from "react";
import { euro } from "@/lib/api";

/** Mobile-only sticky add-to-cart bar, shown when the main CTA is off-screen. */
export function StickyBuyBar({ p, targetId, onAdd, label = "Ajouter" }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const el = document.getElementById(targetId);
    if (!el) return undefined;
    const io = new IntersectionObserver(([e]) => setShow(!e.isIntersecting && e.boundingClientRect.top < window.innerHeight), { threshold: 0 });
    io.observe(el);
    return () => io.disconnect();
  }, [targetId]);
  return (
    <div data-testid="sticky-buy-bar" className={`fixed inset-x-0 bottom-0 z-40 border-t border-[var(--line)] bg-[rgba(11,8,9,0.92)] px-4 py-3 backdrop-blur-lg transition-transform duration-300 lg:hidden ${show ? "translate-y-0" : "translate-y-full"}`}>
      <div className="flex items-center gap-3">
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm">{p.name}</p>
          <p className="text-xs text-[var(--gold-soft)]">{euro(p.price)} · Livraison offerte en Point Relais</p>
        </div>
        <button data-testid="sticky-add-to-cart" onClick={onAdd} className="h-12 shrink-0 rounded-full bg-[var(--gold)] px-5 text-xs font-semibold uppercase tracking-[0.16em] text-[var(--ink)] active:scale-95">{label}</button>
      </div>
    </div>
  );
}
